import { useSelector } from "react-redux";
import { IChannel, RootStateType } from "@Interfaces";

type ChannelAdmin = string | { _id?: string; id?: string } | null;

/**
 * True when the logged-in user is one of the channel's admins.
 * Admins arrive either as plain ids or populated user objects.
 * @param channel - Channel whose admins to check
 */
const useIsChannelAdmin = (channel?: IChannel | null): boolean => {
    const userId = useSelector((state: RootStateType) => state.auth.user?.id);

    if (!userId) return false;

    return (channel?.admins ?? []).some((admin: ChannelAdmin) => {
        const adminId =
            typeof admin === "string" ? admin : admin?._id ?? admin?.id;
        return !!adminId && String(adminId) === String(userId);
    });
};

export default useIsChannelAdmin;
